import { OrganisationSelector } from '@/components';
import { AnalyticsContext, OrganisationContext, UserContext } from '@/context';
import { orderBy } from 'lodash';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { getLink } from '../utils';

const OrganisationMenu = ({ organisations, children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const analytics = useContext(AnalyticsContext);
  const organisation = useContext(OrganisationContext);
  const user = useContext(UserContext);

  const defaultOrganisationKey = user?.preferences?.defaultOrganisationKey;

  const mappedOrganisations = useMemo(
    () =>
      orderBy(
        organisations &&
          organisations.map((org) => {
            let disabled = false;
            let label;
            const favourite = org.key === defaultOrganisationKey;
            if (org.key === organisation?.key) {
              disabled = true;
              label = t('Current Organisation');
            }
            return {
              ...org,
              name: org.name?.trim() || org.key,
              label,
              icon: null,
              favourite,
              disabled,
            };
          }),
        ['favourite', (o) => (o.name || '').toLowerCase()],
        ['desc', 'asc']
      ),
    [defaultOrganisationKey, organisation?.key, organisations, t]
  );

  if (!mappedOrganisations || mappedOrganisations.length === 1) {
    return null;
  }

  return (
    <OrganisationSelector
      organisations={mappedOrganisations}
      onSelected={(selectedOrganisation) => {
        const url = getLink(
          organisation?.key,
          selectedOrganisation.key,
          location
        );
        navigate(url);
        try {
          analytics?.events?.header?.changedSchool({
            key: selectedOrganisation.key,
            name: selectedOrganisation.name,
          });
        } catch (error) {
          // A tracking failure must not cancel the school change.
          console.log('Error tracking school change', error);
        }
      }}
    >
      {children}
    </OrganisationSelector>
  );
};

export default OrganisationMenu;
